import { Text } from '@react-three/drei'
import { s3PublicStoragePrefix } from '../../../utility'
import { Item } from './types'
import { useLoader } from '@react-three/fiber'
import { TextureLoader } from 'three/src/loaders/TextureLoader'
import arrow from '../../../assets/image/cube/kandi-test/arrow.png'

const KandiTile: React.FC<{ item: Item }> = ({ item }) => {
  const fontBolder = `${s3PublicStoragePrefix}custom-static-assets/fonts/countdownFontBolder.ttf`
  const fontBold = `${s3PublicStoragePrefix}custom-static-assets/fonts/countdownFontBold.ttf`

  const images = useLoader(TextureLoader, [item.kandi.outline, arrow])

  return (
    <group position={[0.501, 0, 0]} rotation={[-Math.PI / 2, 0, Math.PI / 2]}>
      <mesh position={[0, -0.0001, 0]} rotation={[Math.PI / 2, 0, 0]}>
        <planeGeometry attach="geometry" args={[1, 1]} />
        <meshBasicMaterial color="#afafaf" attach="material" map={images[0]} transparent premultipliedAlpha />
      </mesh>
      <mesh renderOrder={1} position={[-0.37, -0.001, -0.05]} rotation={[Math.PI / 2, 0, 0]}>
        <planeGeometry attach="geometry" args={[0.15, 0.1]} />
        <meshBasicMaterial attach="material" map={images[1]} transparent premultipliedAlpha />
      </mesh>
      <Text
        font={fontBold}
        fontSize={0.07}
        fontWeight={300}
        color="#ffffff"
        anchorX={0.45}
        anchorY={0.15}
        position={[0, -0.001, 0]}
        rotation={[Math.PI / 2, 0, 0]}
        renderOrder={1}
      >
        Für Dich vor Ort:
      </Text>
      <Text
        font={fontBolder}
        fontSize={0.13}
        fontWeight={700}
        color="#ffffff"
        anchorX={0.45}
        anchorY={0.23}
        position={[0, -0.001, 0]}
        rotation={[Math.PI / 2, 0, 0]}
        renderOrder={1}
      >
        {item.kandi.firstname}
      </Text>
      <Text
        font={fontBolder}
        fontSize={0.13}
        fontWeight={700}
        color="#ffffff"
        anchorX={0.45}
        anchorY={0.35}
        position={[0, -0.001, 0]}
        rotation={[Math.PI / 2, 0, 0]}
        renderOrder={1}
      >
        {item.kandi.lastname}
      </Text>
    </group>
  )
}

export default KandiTile
